function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      admissionGroup: '='
    },
    template: `<span class="badge {{ getClass() }}">
      {{ getText() }}
    </span>`,
    controller: [
      '$scope',
      ($scope) => {
        $scope.getText = function () {
          if ($scope.admissionGroup.status === 'PENDING') return 'Pending';
          else if ($scope.admissionGroup.status === 'DENIED') return 'Denied';
          else if ($scope.admissionGroup.status === 'CONFIRMED') return 'Reserved';
          else if ($scope.admissionGroup.status === 'CHECKED_IN' || $scope.admissionGroup.status === 'CHECKED_IN_PARTIAL' || $scope.admissionGroup.status === 'CHECKED_IN_FULL') return 'Checked-in';
          else if ($scope.admissionGroup.status === 'CANCELLED') return $scope.admissionGroup.cancelledReasonType ? `Cancelled - ${_getCancelledReasonTextByType($scope.admissionGroup.cancelledReasonType)}` : 'Cancelled'; //eslint-disable-line
          else if ($scope.admissionGroup.status === 'CLOSED') return 'Closed';
          return '';
        };

        $scope.getClass = function () {
          if ($scope.admissionGroup.partial) return 'badge-primary badge-purple';
          else if ($scope.admissionGroup.status === 'CHECKED_IN' || $scope.admissionGroup.status === 'CHECKED_IN_PARTIAL' || $scope.admissionGroup.status === 'CHECKED_IN_FULL') return 'badge-success';
          else if ($scope.admissionGroup.status === 'CANCELLED') return 'badge-danger';
          else if ($scope.admissionGroup.status === 'PENDING') return 'badge-closed';
          else if ($scope.admissionGroup.status === 'DENIED') return 'badge-danger';
          else if ($scope.admissionGroup.status === 'CLOSED') return 'badge-closed';
          return '';
        };
      }
    ]
  };
}

function _getCancelledReasonTextByType(type) {
  let text;

  switch (type) {
    case 'NO_SHOW':
      text = 'No Show';
      break;
    case 'FRAUD':
      text = 'For Fraud';
      break;
    case 'USER':
      text = 'By User';
      break;
    case 'VENUE':
      text = 'By Venue';
      break;
    case 'MISTAKE':
      text = 'Mistake';
      break;
    case 'DUPLICATE':
      text = 'Duplicate';
      break;
    default:
      text = '';
  }

  return text;
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/admissionGroupStatusLabel.js